import {ClientAddress} from '../../../graphql/types'

type Address = {
  country?: string | null,
  line1?: string | null,
  city?: string | null,
  zip?: string | null,
  region?: string | null,
}

function getIsAddressValidAccordingProposal(
  {address, addressProposal}:
  {address: ClientAddress | null, addressProposal: Address}
): boolean {
  if (!addressProposal) {
    return true
  }

  if (!address) {
    return false
  }

  const isCountryValid = addressProposal.country ? safeToLowerCase(addressProposal.country) === safeToLowerCase(address.country) : true
  const isLine1Valid = addressProposal.line1 ? addressProposal.line1 === address.line1 : true
  const isCityValid = addressProposal.city ? addressProposal.city === address.city : true
  const isZipValid = addressProposal.zip ? addressProposal.zip === address.zip : true
  const isRegionValid = addressProposal.region ? addressProposal.region === address.region : true

  return isCountryValid && isLine1Valid && isCityValid && isZipValid && isRegionValid
}

function safeToLowerCase(value: string | null) {
  if (!value) return value

  return value.toUpperCase()
}

export {getIsAddressValidAccordingProposal}
